// api.ts - Condition Parameters API Client

import { ApiEndpoints } from "@shared/api/api-endpoints";
import { onboardingApiClient } from "@shared/api/clients/apiClientFactory";
import {
  ConditionParametersResponse,
  CreateConditionParameterRequest,
  UpdateConditionParameterRequest,
  DeleteConditionParameterRequest,
  ConditionParameterAPI,
  ConditionParameter,
} from "./types";

export const conditionParametersApi = {
  // Get all condition parameters
  getConditionParameters: async (
    utilityId: string,
    searchQuery?: string
  ): Promise<ConditionParametersResponse> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "onboarding",
      searchQuery ? "search/onboarding_config" : "config-map/condition",
      (query) => {
        query.push("remote_utility_id", utilityId.toString());
        if (!searchQuery && !searchQuery.trim()) {
          query.push("show_inactive", "true");
        }

        // Add search parameter if provided
        if (searchQuery && searchQuery.trim()) {
          query.push("search_field", "condition");
          query.push("search_data", searchQuery.trim());
        }
      }
    );
    const response = await onboardingApiClient.get(url);
    return response.data;
  },

  // Create new condition parameter
  createConditionParameter: async (
    data: CreateConditionParameterRequest
  ): Promise<{ result: string }> => {
    const url = ApiEndpoints.createUrl("onboarding", "config-map/condition");
    const response = await onboardingApiClient.post(url, data);
    return response.data;
  },

  // Update condition parameter
  updateConditionParameter: async (
    data: UpdateConditionParameterRequest
  ): Promise<{ result: string }> => {
    const url = ApiEndpoints.createUrl("onboarding", "config-map/condition");
    const response = await onboardingApiClient.patch(url, data);
    return response.data;
  },

  deleteConditionParameter: async (data: DeleteConditionParameterRequest) => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "onboarding",
      "config-map/condition",
      (query) => {
        query.push("remote_utility_id", data.remoteUtilityId);
        query.push("code", data.code);
      }
    );
    const response = await onboardingApiClient.delete(url);
    return response.data;
  },
};

// Transform function to convert API response to component format
export const transformConditionParameter = (
  apiParam: ConditionParameterAPI
): ConditionParameter => {
  return {
    id: apiParam.code,
    name: apiParam.name,
    description: apiParam.description || `NA`, // API doesn't provide description
    weightScore: apiParam.score,
    weightage: apiParam.weightage,
    isActive: apiParam.isActive,
    createdBy: apiParam.createdBy,
    createdDate: apiParam.createdDate,
    code: apiParam.code,
  };
};
